// extracted by mini-css-extract-plugin
module.exports = {"stickyElement":"sticky-element-wrapper_stickyElement__AJGCf"};